var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgMastercard = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 48 36"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 48,
  height: 36,
  fill: "#000",
  rx: 6
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#E7001A",
  d: "M19.5 25.5a7.5 7.5 0 1 0 0-15 7.5 7.5 0 0 0 0 15"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#F49B1C",
  d: "M28.5 25.5a7.5 7.5 0 1 0 0-15 7.5 7.5 0 0 0 0 15"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#E7001A",
  fillRule: "evenodd",
  d: "M24 12a7.49 7.49 0 0 1 3 6 7.49 7.49 0 0 1-3 6 7.49 7.49 0 0 1-3-6 7.49 7.49 0 0 1 3-6",
  clipRule: "evenodd",
  opacity: 0.3
})));
export default SvgMastercard;